__turbopack_context__.v({
  "stickyFooter": "FooterStickyNav-module-scss-module__H2GytG__stickyFooter",
});
